import fateImg from '../assets/characters/fate.png';
import fameImg from '../assets/characters/fame.png';
import fortuneImg from '../assets/characters/fortune.png';

export type CharacterId = 'fate' | 'fame' | 'fortune';

export type CharacterOption = {
  id: CharacterId;
  title: string;
  subtitle: string;
  locked: boolean;
  description: string;
  // Optional art image (png/jpg). If omitted, we render a styled placeholder.
  imageSrc?: string;
};

export const CHARACTER_OPTIONS: CharacterOption[] = [
  {
    id: 'fate',
    title: 'Fate',
    subtitle: 'The Intended',
    locked: false,
    description: 'The only playable character (for now).',
    imageSrc: require('../assets/characters/fate.png'),
  },
  {
    id: 'fame',
    title: 'Fame',
    subtitle: 'The Celebrated',
    locked: true,
    description: 'Locked. Coming later.',
    imageSrc: require('../assets/characters/fame.png'),
  },
  {
    id: 'fortune',
    title: 'Fortune',
    subtitle: 'The Favored',
    locked: true,
    description: 'Locked. Coming later.',
    imageSrc: require('../assets/characters/fortune.png'),
  },
];
